import React from "react";
import { Growl } from "primereact/growl";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Paginator } from 'primereact/paginator';
import { Message } from "primereact/message";
import servicioArchivos from '../servicio/ServicioArchivos';
import servicioHttp from "../servicio/ServicioHttp";
import servicioObjetos from '../servicio/ServicioObjetos';
import servicioFormatos from '../servicio/ServicioFormatos';
import servicioGeneradorAnios from '../servicio/ServicioGeneradorAnios';

const TODOS = { label: "Todos", value: 0 };
const MESES = [
    { label: "Enero", value: "Enero" },
    { label: "Febrero", value: "Febrero" },
    { label: "Marzo", value: "Marzo" },
    { label: "Abril", value: "Abril" },
    { label: "Mayo", value: "Mayo" },
    { label: "Junio", value: "Junio" },
    { label: "Julio", value: "Julio" },
    { label: "Agosto", value: "Agosto" },
    { label: "Septiembre", value: "Septiembre" },
    { label: "Octubre", value: "Octubre" },
    { label: "Noviembre", value: "Noviembre" },
    { label: "Diciembre", value: "Diciembre" }];

const ANIOS = servicioGeneradorAnios.generarAnios();

const JOIN_PRINCIPAL = {
    "tcEmpresa": "alias_tcEmpresa",    
};

const PAGINACION_INICIAL={
    registrosPorPagina: 10,
    join: null,
    restriccionesDinamicas: [
    ]
}
export class Consolidado extends React.Component {
    constructor() {
        super();
        this.state = {
            consulta: {},            
            verModalConsolidadoEma: false,
            verModalConsolidadoEba: false,
            registrosPatronales: [],            
            idsenube: 0,
            paginacion: PAGINACION_INICIAL,
            errores: {},
            listaEmisionMensualAnticipada: [],            
        };
    }

    componentDidMount() {
        this.obtenerRegistrosPatronales();
    }

    obtenerRegistrosPatronales = () => {
        servicioHttp.consumirPostHttp('empresa/obtener_registro_patronal.json').then(response => {
            let registrosPatronales = [TODOS];
            var newArray = registrosPatronales.concat(response.data.lista);
            let { consulta } = this.state;
            consulta.registroPatronal = TODOS.value
            consulta.mes = TODOS.value;
            consulta.anio = TODOS.value;
            let arregloMeses = [TODOS];
            arregloMeses = arregloMeses.concat(MESES);

            let arregloAnios = [TODOS];
            arregloAnios = arregloAnios.concat(ANIOS);
            this.setState({ registrosPatronales: newArray, consulta: consulta, meses: arregloMeses, anios: arregloAnios });
        }).catch(error => {

        });
    };

    asignarValores = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
    }

    consultarEmision = () => {
        let { consulta } = this.state;
        const validacion = this.validarFormulario(consulta);
        this.setState({ errores: validacion });
        if (servicioObjetos.esObjetoVacio(validacion)) {
            this.asignarRestricciones();
            let { paginacion } = this.state;
            servicioHttp.consumirPostHttp('emision/consultar.json', paginacion).then(response => {
                this.setState({ paginacion: response.data.objeto });
            }).catch(error => {

            });
        }
    }

    asignarRestricciones = () => {
        let { consulta, paginacion, registrosPatronales } = this.state;
        paginacion.join = JOIN_PRINCIPAL;
        paginacion.restriccionesDinamicas = [];
        if (!servicioObjetos.esObjetoVacio(consulta.registroPatronal)) {
            if (consulta.registroPatronal !== 0) {
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "eq",
                    nombrePropiedad: "alias_tcEmpresa.id",
                    valorPropiedad: consulta.registroPatronal
                });
            } else {
                let empresasUsuarioSesion = [];
                for (let index = 0; index < registrosPatronales.length; index++) {
                    let elemento = registrosPatronales[index];
                    if (elemento.value !== 0) {
                        let valor = elemento.value;
                        empresasUsuarioSesion.push(
                            valor
                        );
                    }
                }
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "in",
                    nombrePropiedad: "alias_tcEmpresa.id",
                    coleccionIn: empresasUsuarioSesion
                });
            }
        }

        if (consulta.anio !== 0 && consulta.mes !== 0) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "periodo",
                valorPropiedad: consulta.mes + " " + consulta.anio
            });
        }
        if (consulta.anio !== 0 && consulta.mes === 0) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "like",
                nombrePropiedad: "periodo",
                valorPropiedad: consulta.anio,
                modoLike: "ANYWHERE"
            });
        }
    }
    consultarEma = (objeto) => {
        let paginacionWrapper = {
            registrosPorPagina: 10,
            join: {
                "ttEmision":"alias_ttEmision",
                "alias_ttEmision.tcEmpresa":"alias_tcEmpresa"
            },
            restriccionesDinamicas: [
                {
                    tipoRestriccion: "eq",
                    nombrePropiedad: "alias_ttEmision.id",
                    valorPropiedad: objeto.id
                }
            ]
        }
        servicioHttp.consumirPostHttp('resumenemcionema/consultar.json',paginacionWrapper).then(response => {
            this.setState({ verModalConsolidadoEma: true,listaEmisionMensualAnticipada:response.data.objeto.datos });
        }).catch(error => {

        });        
    }

    consultarEba = (objeto) => {
        let paginacionWrapper = {
            registrosPorPagina: 10,
            join: {
                "ttEmision":"alias_ttEmision",
                "alias_ttEmision.tcEmpresa":"alias_tcEmpresa"
            },
            restriccionesDinamicas: [
                {
                    tipoRestriccion: "eq",
                    nombrePropiedad: "alias_ttEmision.id",
                    valorPropiedad: objeto.id
                }
            ]
        }
        servicioHttp.consumirPostHttp('resumenemcioneba/consultar.json',paginacionWrapper).then(response => {
            this.setState({ verModalConsolidadoEba: true,listaEmisionBimestralAnticipada:response.data.objeto.datos });
        }).catch(error => {

        });             
    }

    resetFormulario = () => {
        this.setState({ verModalConsolidadoEma: false , verModalConsolidadoEba: false,errores: {} });
    };

    validarFormulario = (consulta) => {
        const errores = {};
        if (consulta.registroPatronal === 0 && consulta.mes === 0 && consulta.anio === 0) {
            errores.anio = "Seleccione año";
            errores.mes = "Seleccione mes";
            errores.registroPatronal = "Selecciones un registro patronal";
        }

        if (consulta.mes !== 0 && consulta.anio === 0) {
            errores.anio = "Seleccione año";
        }
        return errores;
    };

    plantillaEma = (rowData, column) => {
        return (
            <Button
                label={servicioFormatos.formatearModena(rowData.saldoEma)}
                tooltip="EMA"
                onClick={() => this.consultarEma(rowData)}
                className="p-button-secondary"
            ></Button>
        );
    }

    plantillaRegistroPatronal = (rowData, column) => {
        return (
        <span className="cursor" onClick={this.mostrarModalRegistro}><strong>{rowData.registroPatronal}</strong></span>
        );
    }

    plantillaEba = (rowData, column) => {
        return (
            <Button
                label={servicioFormatos.formatearModena(rowData.saldoEba)}
                tooltip="EBA"
                onClick={() => this.consultarEba(rowData)}
                className="p-button-secondary"                
            ></Button>
        );
    }

    descargaExcel = () => {
        this.asignarRestricciones();
        let { paginacion } = this.state;
        servicioArchivos.descargaArchivo('/emision/descargar_excel.json', paginacion, this);
    }

    descargaExcelEma = () => {
        let {listaEmisionMensualAnticipada} =this.state;
        let paginacionWrapper = {
            registrosPorPagina: 10,
            join: {
                "ttEmision":"alias_ttEmision",
                "alias_ttEmision.tcEmpresa":"alias_tcEmpresa"
            },
            restriccionesDinamicas: [
                {
                    tipoRestriccion: "eq",
                    nombrePropiedad: "id",
                    valorPropiedad: listaEmisionMensualAnticipada[0].id
                }
            ]
        }
        servicioArchivos.descargaArchivo('resumenemcionema/descargar_excel.json', paginacionWrapper, this);
    }

    descargaExcelEba = () => {
        let {listaEmisionBimestralAnticipada }=this.state;
        let paginacionWrapper = {
            registrosPorPagina: 10,
            join: {
                "ttEmision":"alias_ttEmision",
                "alias_ttEmision.tcEmpresa":"alias_tcEmpresa"
            },
            restriccionesDinamicas: [
                {
                    tipoRestriccion: "eq",
                    nombrePropiedad: "id",
                    valorPropiedad: listaEmisionBimestralAnticipada[0].id
                }
            ]
        }
        servicioArchivos.descargaArchivo('resumenemcioneba/descargar_excel.json', paginacionWrapper, this);
    }

    cerrarModalEma = () =>{
        this.setState({verModalConsolidadoEma:false,listaEmisionMensualAnticipada:[]});
    }

    cerrarModalEba = () =>{
        this.setState({verModalConsolidadoEba:false,listaEmisionBimestralAnticipada:[]});
    }

    reiniciarFrmBusqueda = () => {
        this.setState({consulta:{},errores:{},paginacion:PAGINACION_INICIAL});
        this.obtenerRegistrosPatronales();
    }

    cambiaPagina = (event) => {
        this.asignarRestricciones();        
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ idsenube: event.first });
        this.consultarEmision();
    }

    render() {

        let { paginacion, errores, registrosPatronales, consulta,
            anios, meses, idsenube, verModalConsolidadoEma, listaEmisionMensualAnticipada, verModalConsolidadoEba,
            listaEmisionBimestralAnticipada } = this.state;

        let pieTablaExportar = <div className="p-fluid p-grid">
            <div className="p-col-12 p-md-2">
                {!servicioObjetos.esObjetoVacio(paginacion.datos) ? <Button className="p-button-secondary" type="button" onClick={this.descargaExcel} name="Excel" label="Excel" icon="pi-md-import-export" tooltip="Excel"></Button> : null}
            </div>
        </div>;
        
        let pieTablaExportarEma = <div className="p-fluid p-grid">
            <div className="p-col-12 p-md-2">
                {!servicioObjetos.esObjetoVacio(listaEmisionMensualAnticipada) ? <Button className="p-button-secondary" type="button" onClick={this.descargaExcelEma} name="Excel" label="Excel" icon="pi-md-import-export" tooltip="Excel"></Button> : null}
            </div>
        </div>;

        let pieTablaExportarEba = <div className="p-fluid p-grid">
            <div className="p-col-12 p-md-2">
                {!servicioObjetos.esObjetoVacio(listaEmisionBimestralAnticipada) ? <Button className="p-button-secondary" type="button" onClick={this.descargaExcelEba} name="Excel" label="Excel" icon="pi-md-import-export" tooltip="Excel"></Button> : null}
            </div>
        </div>;

        const pieDialogoEma = (
            <div className="ui-dialog-buttonpane p-clearfix">
                <Button label="Cerrar" icon="pi-md-close" onClick={this.cerrarModalEma} className="p-button-danger " />
            </div>
        );
        const pieDialogoEba = (
            <div className="ui-dialog-buttonpane p-clearfix">
                <Button label="Cerrar" icon="pi-md-close" onClick={this.cerrarModalEba} className="p-button-danger " />
            </div>
        );

        return (
            <div className="p-fluid">
                <Growl ref={(el) => (this.growl = el)} />
                <div className="card card-w-title">
                    <h1>Consolidado</h1>
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-4">
                            <Dropdown filter={true} filterPlaceholder="Filtra por RP o Nombre corto" 
                            filterBy="value,label" showClear={true}
                            appendTo={document.body} id="consulta.registroPatronal" 
                            name="consulta.registroPatronal" optionLabel="label" optionValue="value"
                            options={registrosPatronales} value={consulta.registroPatronal} onChange={(e) => this.asignarValores(e, false)} autoWidth={false} style={{ width: "100%" }} />
                            {errores.registroPatronal ? (<div><br /> <Message severity="error" text={errores.registroPatronal} />{" "}</div>) : null}
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label >*Periodo:</label>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <Dropdown appendTo={document.body} placeholder="Año:" 
                            id="consulta.anio" name="consulta.anio" optionLabel="label" optionValue="value"
                            options={anios} value={consulta.anio} 
                            onChange={(e) => this.asignarValores(e, false)} autoWidth={false} />
                            {errores.anio ? <div><br /> <Message severity="error" text={errores.anio} /> </div> : null}
                        </div>
                        <div className="p-col-12 p-md-3">
                            <Dropdown appendTo={document.body} placeholder="Mes:" id="consulta.mes" 
                            name="consulta.mes" optionLabel="label" optionValue="value" options={meses} 
                            value={consulta.mes} onChange={(e) => this.asignarValores(e, false)} 
                            autoWidth={false} />
                            {errores.mes ? <div><br /> <Message severity="error" text={errores.mes} /> </div> : null}
                        </div>                        
                        <div className="p-col-12 p-md-2"><Button label="Limpiar" icon="pi-md-refresh" onClick={this.reiniciarFrmBusqueda} /></div>
                        <div className="p-col-12 p-md-2"><Button label="Buscar" icon="pi-md-search" onClick={this.consultarEmision} /></div>                  
                    </div>
                </div>
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card">
                            <DataTable footer={pieTablaExportar} value={paginacion.datos} editable={true} responsive={true} header="Consolidado de Emisiones" resizableColumns={true}>
                                <Column header="Registro Patronal" body={this.plantillaRegistroPatronal} autoLayout={true} resizableColumns={true} />
                                <Column header="Periodo" field="periodo" autoLayout={true} resizableColumns={true}  />
                                <Column header="Saldo EMA" body={this.plantillaEma} autoLayout={true} resizableColumns={true} />
                                <Column header="Saldo EBA" body={this.plantillaEba} autoLayout={true} resizableColumns={true}  />
                            </DataTable>
                            <Paginator first={idsenube} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina} rowsPerPageOptions={[10, 20, 40, 60, 80, 100]} />
                        </div>
                    </div>
                </div>

                <Dialog footer={pieDialogoEma} style={{ width: "80%" }} appendTo={document.body} visible={verModalConsolidadoEma} header="Emisión Mensual Anticipada" modal={true} onHide={this.cerrarModalEma}>
                    <DataTable footer={pieTablaExportarEma} header="Emisión Mensual Anticipada" value={listaEmisionMensualAnticipada} responsive={true} resizableColumns={true}>
                        <Column header="Registro Patronal" field="registroPatronal" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Periodo" field="periodo" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Número de propuesta" field="numDeCredito" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Días" field="dias" autoLayout={true} resizableColumns={true} style={{ width: '80px' }} />
                        <Column header="Total cotizantes" field="numDeTrabajadoresCotizantes" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Prima de grado de riesgo" field="primaDeRiesgoDeTrabajo" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Tipo de documento" field="tipoDocumento" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Cuota Fija" field="cuotaFija" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Excedente Patronal" field="excedentePatronal" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Exedente Obrero" field="excedenteObrero" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Prestaciones en dinero patronal" field="penDineroPatronal" autoLayout={true} resizableColumns={true} style={{ width: '250px' }} />
                        <Column header="Prestaciones en dinero obrero" field="penDineroObrero" autoLayout={true} resizableColumns={true} style={{ width: '250px' }} />
                        <Column header="Gastos médicos y pensionados patronal" field="gmedicosPenPatronal" autoLayout={true} resizableColumns={true} style={{ width: '250px' }} />
                        <Column header="Gastos médicos y pensionados obrero" field="gmedicosPenObrero" autoLayout={true} resizableColumns={true} style={{ width: '250px' }} />
                        <Column header="Riesgo de trabajo" field="rtrabajo" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Invalidez y vida patronal" field="invYVidaPatronal" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Invalidez y vida obrero" field="invYVidaObrero" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Guarderías y Prestaciones Sociales" field="guarderias" autoLayout={true} resizableColumns={true} style={{ width: '250px' }} />
                        <Column header="Total" field="totalImss" autoLayout={true} resizableColumns={true} style={{ width: '100px' }} />                        
                    </DataTable>
                </Dialog>

                <Dialog footer={pieDialogoEba} appendTo={document.body} visible={verModalConsolidadoEba} style={{ width: "80%" }} header="Emisión Bimestral Anticipada" modal={true} onHide={this.cerrarModalEba}>
                    <DataTable footer={pieTablaExportarEba} header="Emisión Bimestral Anticipada" value={listaEmisionBimestralAnticipada} responsive={true} resizableColumns={true}>
                        <Column header="Registro Patronal" field="registroPatronal" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Periodo" field="periodo" autoLayout={true} resizableColumns={true} style={{ width: '100px' }} />
                        <Column header="Número de crédito" field="numDeCredito" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Prima riesgo al trabajo" field="primaDeRiesgoDeTrabajo" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Trabajadores cotizantes" field="numDeTrabajadoresCotizantes" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Tipo de documento" field="tipoDocumento" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Trabajadores acreditados" field="trabajadoresAcreditados" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Total Aportación Pat. Infonavit" field="aportacionPatronal" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Aportación Pat. S/C Infonavit" field="aportacionPatronalSc" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Aportación Pat. C/C Infonavit" field="aportacionPatronalCc" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Amortización" field="amortizacion" autoLayout={true} resizableColumns={true} style={{ width: '150px' }} />
                        <Column header="Total Infonavit" field="totlaInf" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Retiro" field="impRetiro" autoLayout={true} resizableColumns={true} style={{ width: '150px' }} />
                        <Column header="Cesantía y vejez Patronal" field="cesaYVejPatronal" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Cesantía y vejez Obrero" field="cesaYVejObrero" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                        <Column header="Total RCV" field="totalRcv" autoLayout={true} resizableColumns={true} style={{ width: '100px' }} />
                        <Column header="Total" field="saldoEba" autoLayout={true} resizableColumns={true} style={{ width: '100px' }} />                        
                    </DataTable>
                </Dialog>
            </div >
        );

    }
}